// src/components/common/GlassyIcon.js

const GlassyIcon = ({ icon: Icon, size = 'md', color = 'orange', customGradient = null, customShadow = null, className = '' }) => {
  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
  };

  const iconSizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  // Map color prop to Tailwind classes using CSS variables
  const getColorClasses = (colorName) => {
    switch (colorName) {
      case 'orange':
        return 'bg-gradient-to-br from-[var(--color-glassy-orange)] to-[var(--color-glassy-orange-to)] shadow-md shadow-orange-500/40';
      case 'green':
        return 'bg-gradient-to-br from-[var(--color-glassy-green)] to-[var(--color-glassy-green-to)] shadow-md shadow-green-500/40';
      case 'blue':
        return 'bg-gradient-to-br from-[var(--color-glassy-blue)] to-[var(--color-glassy-blue-to)] shadow-md shadow-blue-500/40';
      case 'purple':
        return 'bg-gradient-to-br from-[var(--color-glassy-purple)] to-[var(--color-glassy-purple-to)] shadow-md shadow-purple-500/40';
      case 'red':
        return 'bg-gradient-to-br from-[var(--color-glassy-red)] to-[var(--color-glassy-red-to)] shadow-md shadow-red-500/40';
      case 'emerald':
        return 'bg-gradient-to-br from-[var(--color-glassy-emerald)] to-[var(--color-glassy-emerald-to)] shadow-md shadow-emerald-500/40';
      case 'amber':
        return 'bg-gradient-to-br from-[var(--color-glassy-amber)] to-[var(--color-glassy-amber-to)] shadow-md shadow-amber-500/40';
      case 'violet':
        return 'bg-gradient-to-br from-[var(--color-glassy-violet)] to-[var(--color-glassy-violet-to)] shadow-md shadow-violet-500/40';
      case 'neutral':
        return 'bg-gradient-to-br from-[var(--color-glassy-neutral)] to-[var(--color-glassy-neutral-to)] shadow-md shadow-gray-500/40';
      case 'pink':
        return 'bg-gradient-to-br from-[var(--color-glassy-pink)] to-[var(--color-glassy-pink-to)] shadow-md shadow-pink-500/40';
      case 'white':
        return 'bg-gradient-to-br from-white/90 to-white/70 shadow-md shadow-gray-300/40';
      default:
        return 'bg-gradient-to-br from-[var(--color-glassy-orange)] to-[var(--color-glassy-orange-to)] shadow-md shadow-orange-500/40';
    }
  };

  const customStyle = customGradient
    ? {
        background: customGradient,
        boxShadow: customShadow || '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      }
    : {};

  return (
    <div
      className={`
        ${sizeClasses[size]} rounded-xl flex items-center justify-center 
        border border-white/20 backdrop-blur-sm
        ${customGradient ? '' : getColorClasses(color)}
        ${className}
      `}
      style={customStyle}
    >
      <Icon className={`${iconSizes[size]} text-white drop-shadow-sm`} />
    </div>
  );
};

export default GlassyIcon;
